import { render } from "./CermetView.vue?vue&type=template&id=7129ddff&scoped=true"
import script from "./CermetView.vue?vue&type=script&lang=js"
export * from "./CermetView.vue?vue&type=script&lang=js"

import "./CermetView.vue?vue&type=style&index=0&id=7129ddff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7129ddff"]])

export default __exports__